import { createFileRoute } from "@tanstack/react-router";
import HowLongDoesTmsTreatmentLastPage from "@/pages/articles/HowLongDoesTmsTreatmentLastPage";
export const Route = createFileRoute("/how-long-does-a-tms-treatment-last")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "How Long Does TMS Treatment Last? | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Learn how long each TMS session lasts (18–20 min), the full 6-week course timeline, and how accelerated SAINT® TMS condenses treatment into 5 days.",
        },
        {
          property: "og:title",
          content: "How Long Does TMS Treatment Last? | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Learn how long each TMS session lasts (18–20 min), the full 6-week course timeline, and how accelerated SAINT® TMS condenses treatment into 5 days.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/how-long-does-a-tms-treatment-last",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-long-does-a-tms-treatment-last",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowLongDoesTmsTreatmentLastPage />;
}
